import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Login/GenerateQrContent', method: 'POST', token: token })
}
